import * as React from 'react'
import { connect } from 'react-redux'
import { ErrorGroup, errorGroupIsNonCritical, errorGroupTitle, IssueType } from '../domain/Error'

import LargeNumber from '../helper/large-number'

import Link from '../helper/link'
import Milliseconds from '../helper/milliseconds'
import MomentDate from '../momentDate'
import { ApplicationState } from '../redux/ApplicationState'
import StatusLabel from './listStatusLabel'

interface Props {
    error: ErrorGroup
    parameters: {
        error?: string
    }
    currentPage: number
    currentRoute: string
}

export class ErrorListItemComponent extends React.Component<Props> {
    public render() {
        const error = this.props.error
        const isActiveError = this.props.parameters.error === error.id

        const routeParams = {
            ...this.props.parameters,
            error: error.id,
            page: this.props.currentPage,
            offset: 0,
        }

        const title = errorGroupTitle(error)

        return (
            <div className={'error-item' + (isActiveError ? ' active' : '')}>
                <Link route={this.props.currentRoute} params={routeParams}>
                    {error.level !== IssueType.RELEASE ? <StatusLabel status={error.status} /> : null}
                    {!error.notify ? (
                        <div
                            className="pull-right tw-mr-8 tw-tooltip tw-tooltip-dataText tw-tooltip--bottom"
                            data-tooltip-text="Notifications muted"
                        >
                            <i className="fa fa-microphone-slash" />
                        </div>
                    ) : null}
                    <div className="error-item-type text-ellipsis">
                        {error.occurancesSinceLastRelease > 0 && (
                            <small
                                data-toggle="tooltip"
                                title={error.occurancesSinceLastRelease + ' occurrences since last release'}
                                className="label label-warning"
                            >
                                <LargeNumber class="" useUnitClass={false} value={error.occurancesSinceLastRelease} />x
                            </small>
                        )}
                        {error.occurances > 1 && error.occurances !== error.occurancesSinceLastRelease && (
                            <small
                                data-toggle="tooltip"
                                title={error.occurances + ' occurrences in total'}
                                className="label label-outline-default"
                            >
                                <LargeNumber class="" useUnitClass={false} value={error.occurances} />x
                            </small>
                        )}
                        <span title={title}>{title}</span>
                    </div>
                    <div className="error-item-source text-ellipsis">
                        {errorGroupIsNonCritical(error) ? error.originatingFunction : error.source}
                    </div>
                    {error.level === IssueType.SLOWSQL && 'duration' in error.annotations && (
                        <div className="error-item-duration">
                            Query Time:&nbsp;
                            <Milliseconds class="slow-sql-list" value={parseInt(error.annotations.duration, 10)} />
                        </div>
                    )}
                    <div className="error-item-time">
                        {error.lastOccured ? <MomentDate date={error.lastOccured.date} /> : <MomentDate date={error.firstOccured.date} />}
                    </div>
                </Link>
            </div>
        )
    }
}

export default connect((globalState: ApplicationState) => {
    return {
        parameters: globalState.tidewaysContext.route.parameters,
        currentRoute: globalState.tidewaysContext.route.route,
    }
})(ErrorListItemComponent)
